import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../images/logo/logo.jpg";
import './shining.css'; // Ensure this is your CSS file path

function Navbar() {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = useState(false);

  const aboutBtn = () => {
    // Check if the current location is already the home page
    if (window.location.pathname !== "/") {
      // Navigate to the home page
      navigate("/");
    }

    // After navigating to the home page, scroll to the pick-section
    setTimeout(() => {
      document
        .querySelector("#choosing-section")
        .scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const closeNav = () => {
    setNavOpen(false);
  };

  const bookBtn = () => {
    // Check if the current location is already the home page
    if (window.location.pathname !== "/") {
      // Navigate to the home page
      navigate("/");
    }


    // After navigating to the home page, scroll to the pick-section
    setTimeout(() => {
      document
        .querySelector("#pick-section")
        .scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  {/* 
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
*/}



  return (
    <div style={{ marginBottom: "35px", backgroundColor:'#00b712s'}}>
      
     

      <nav
        className="navbar navbar-expand-lg navbar-light"
        style={{
          // boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
         //borderBottomLeftRadius: "30px",
         //borderBottomRightRadius: "30px",
          height: "104px", width: '100%',
          //position: "fixed",
          marginTop: "14px",
          //background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)',
         // backgroundSize: '200% 200%',
         // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)', 
         width:'100%', 
          padding: '20px',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center',
         // animation: 'glow 1.5s infinite alternate, shine 1s infinite linear',
        }}
      > 
        {/* */}
        <div className="container">
          {/* Logo */}

            <Link
            className="navbar-brand"
            to="/"
            onClick={() => window.scrollTo(0, 0)}
          >
     
          </Link>

          {/* Mobile Menu Toggle */}
          <button className="navbar-toggler" type="button" onClick={toggleNav} style={{borderWidth:'2px', borderColor:'white', backgroundColor:'gold'}}>
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div
            className={`collapse navbar-collapse ${navOpen ? "show" : ""}`}
            style={{ backgroundColor: navOpen ? "black" : ""   }}
          >
            <ul
              className="navbar-nav ml-auto"
              style={{ paddingTop: "15px", paddingLeft: "4px" }}
            >
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/"
                  onClick={closeNav}
                  style={{
                    paddingLeft: "1px",
                    color: "white",
                    transition: "color 0.3s",
                    marginLeft: "11px",  fontSize: "18px", fontWeight:'bold'
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#00FFFF")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "white")} // Reset color on mouse out
                >
                  HOME
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/"
                  onClick={() => {
                    aboutBtn();
                    closeNav();
                  }}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "white",
                    transition: "color 0.3s", fontSize: "18px", fontWeight:'bold'
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#00FFFF")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "white")} // Reset color on mouse out
                >
                  ABOUT
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/atv-tours"
                  onClick={() => {
                    bookBtn();
                    closeNav();
                  }}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "white",
                    transition: "color 0.3s", fontSize: "18px", fontWeight:'bold'
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#00FFFF")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "white")} // Reset color on mouse out
                >
                  ATV TOURS
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/testimonials"
                  onClick={closeNav}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "white",
                    transition: "color 0.3s", fontSize: "18px", fontWeight:'bold'
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#00FFFF")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "white")} // Reset color on mouse out
                >
                  TESTIMONIALS
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/contact"
                  onClick={closeNav}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "white",
                    transition: "color 0.3s", fontSize: "18px", fontWeight:'bold'
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#00FFFF")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "white")} // Reset color on mouse out
                >
                  CONTACT
                </Link>
              </li>
            </ul>
          </div>
        </div>

      </nav>






    </div>
  );
}

export default Navbar;
